import {SODeleteInterphace} from '../../core/interphace/so-delete-interphace';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteInterphace extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteInterphace;
}